module.exports = __webpack_public_path__ + "static/media/ic_product_st_archive.0cb2aac0.svg";